import EFPicture from 'elem/compCommon/EFPicture';
import JoinUsI from 'elem/SVGIcon/OutdoorRecreation/JoinUs';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function JoinUs() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('powerbackup');
    return (
        <div id="outdoor-recreation-JoinUs" className={`outdoor-recreation-JoinUs ${css['outdoor-recreation-JoinUs']}`}>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/power-backup/join_us_1366_au.jpg"
                    srcDesktop="/responsive/picture/power-backup/join_us_1366_au.jpg"
                    srcPad="/responsive/picture/power-backup/join_us_768_au.jpg"
                    srcMobile="/responsive/picture/power-backup/join_us_768_au.jpg"
                    alt={t('secQ')}
                />
                <div className="text-content">
                    <JoinUsI />
                    <p className="desc">{t('secQ')}</p>
                    <Link
                        className="join-us-btn"
                        href="https://www.facebook.com/groups/efaustralia/"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'activity_button',
                            page_name: 'power-backup',
                            list_name: t('secJ_title'),
                            button_name: t('secQ_btn'),
                            function: 'Join Community',
                        }}
                    >
                        {t('secQ_btn')}
                    </Link>
                </div>
            </div>
        </div>
    );
}
